export const isDateString = (str: string) => {
  const timestamp = Date.parse(str);
  return !isNaN(timestamp);
};
